export default [
  {
    path: "/milon-stats",
    name: "milonStats",
    component: () => import("@/views/milon/MilonStats.vue"),
    meta: {
      rights: ["stat_admin"],
      navbarTitle: "Milon",
      hideLogo: true,
      showBackButton: true,
      backTo: "/",
    },
  },
]
